export { default as component } from "../../../../src/routes/[prefix]/(main)/setting/+page.svelte";